import { Icon } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import {
  ActionButton,
  ActionButtonWithTrailingSpace,
  ActionsLabel
} from './ActionButtons.styles'

type ActionButtons = {
  onSubmit?: () => void
  onClear?: () => void
}

const ActionButtons = ({ onSubmit, onClear }: ActionButtons) => {
  const { t } = useTranslation()
  return (
    <div className='col-md-2 align-self-end'>
      <ActionsLabel>{t('action-buttons.actions')}</ActionsLabel>

      <div className='row d-md-none'>
        <div className='col-6'>
          <ActionButtonWithTrailingSpace type='submit' onClick={onSubmit}>
            {t('action-buttons.submit')}
          </ActionButtonWithTrailingSpace>
        </div>
        <div className='col-6'>
          <ActionButton type='button' variant='secondary' onClick={onClear}>
            {t('action-buttons.clear')}
          </ActionButton>
        </div>
      </div>

      <div
        className='d-none d-md-grid'
        style={{
          gridAutoColumns: '36px',
          gridAutoFlow: 'column',
          gap: '0.25rem'
        }}
      >
        <ActionButtonWithTrailingSpace
          type='submit'
          onClick={onSubmit}
          title={t('action-buttons.submit')}
          className='d-flex align-items-center justify-content-center'
        >
          <Icon iconName='Filters' icSize='small' />
        </ActionButtonWithTrailingSpace>
        <ActionButton
          type='button'
          variant='secondary'
          onClick={onClear}
          title={t('action-buttons.clear')}
        >
          <Icon iconName='Rubber' icSize='regular' />
        </ActionButton>
      </div>
    </div>
  )
}

export default ActionButtons
